import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Box, Button, Stack, Typography } from '@mui/material';
import { ChangeEvent, memo } from 'react';
import { FieldType } from '../../types';
import * as Styled from './styles';
import * as SX from './sx';
import type { WhiteLabelTextFieldProps as Props } from './types';

export const WhiteLabelTextField = memo(({ className, item }: Props) => {
  const {
    endIcon,
    startIcon,
    error,
    errorMessage,
    label,
    placeholder,
    color,
    onChange,
    onChangeFile,
    value,
    file,
    fieldType,
  } = item;

  const handleChange = (
    e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    onChange?.(e.target.value);
  };

  return (
    <Stack gap={0.5}>
      {label && <Typography sx={SX.label}>{label}</Typography>}
      <Styled.Wrapper
        className={classnames('WhiteLabelTextField', className)}
        sx={SX.root(error)}
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        {startIcon && <Icon name={startIcon} sxx={SX.startIcon} />}
        {fieldType === FieldType.TEXT ? (
          <Styled.Input
            fullWidth
            placeholder={placeholder}
            onChange={handleChange}
            value={value}
          />
        ) : (
          <Stack alignItems="center" justifyContent="center" sx={SX.fileName}>
            {file?.name}
          </Stack>
        )}

        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          gap={1}
        >
          {error && <Icon name="info" size={18} sxx={SX.errorIcon} />}
          {color && !error && <Box sx={SX.colorBox(color)} />}
          {endIcon &&
            (fieldType === FieldType.FILE ? (
              <Button sx={SX.fileBtn} component="label">
                <Icon name={endIcon} size={18} sxx={SX.endIcon} />
                <Styled.VisuallyHiddenInput
                  type="file"
                  accept=".svg"
                  onChange={onChangeFile}
                />
              </Button>
            ) : (
              <Icon name={endIcon} size={18} sxx={SX.endIcon} />
            ))}
        </Stack>
      </Styled.Wrapper>
      {errorMessage && (
        <Typography sx={SX.errorMessage}>{errorMessage}</Typography>
      )}
    </Stack>
  );
});

WhiteLabelTextField.displayName = 'WhiteLabelTextField';
